// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.1
//   protoc               unknown
// source: configd/rest_bgp.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { RestError } from "../common/error";
import { BgpPeer, BgpPolicy } from "../models/routing";

export const protobufPackage = "configd";

/** The response returned to a request for the list of BGP policies in a specific fabric. */
export interface FabricBgpPoliciesResponse {
  /** The list of BGP policies in the fabric */
  policies: BgpPolicy[];
  /** Returned error if issue hit during streaming response. */
  error: RestError | undefined;
}

/** The request for the list of BGP policies in a specific fabric. */
export interface GetFabricBgpPoliciesRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** The candidate configuration name. If not set the default candidate configuration values are returned. */
  candidate: string;
  /** Include object metadata in the response. */
  includeMetadata: boolean;
}

/** The request for a specific BGP policy in a fabric. */
export interface GetFabricBgpPolicyRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** The BGP policy id or name. */
  policyId: string;
  /** The candidate configuration name. If not set the default candidate configuration values are returned. */
  candidate: string;
  /** Include object metadata in the response. */
  includeMetadata: boolean;
}

/** The request to add one or more BGP policies to a specific fabric. */
export interface AddFabricBgpPoliciesRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** A list of BGP policies to be added to the fabric. */
  policies: BgpPolicy[];
}

/** The request to update a specific BGP policies in a fabric. */
export interface UpdateFabricBgpPolicyRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** The BGP policy id or name. */
  policyId: string;
  /** The updated BGP policy definition */
  policy: BgpPolicy | undefined;
}

/** The request to delete a specific BGP policy in a fabric. */
export interface DeleteFabricBgpPolicyRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** The BGP policy id or name. */
  policyId: string;
}

/** The response returned to a request for the list of BGP policies in a specific fabric. */
export interface FabricBgpPeersResponse {
  /** The list of BGP policies in the fabric */
  peers: BgpPeer[];
  /** Returned error if issue hit during streaming response. */
  error: RestError | undefined;
}

/** The request for the list of BGP peers in a specific fabric. */
export interface GetFabricBgpPeersRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** The candidate configuration name. If not set the default candidate configuration values are returned. */
  candidate: string;
  /** Include object metadata in the response. */
  includeMetadata: boolean;
}

/** The request for a specific BGP peer in a fabric. */
export interface GetFabricBgpPeerRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** The BGP peer id or name. */
  peerId: string;
  /** The candidate configuration name. If not set the default candidate configuration values are returned. */
  candidate: string;
  /** Include object metadata in the response. */
  includeMetadata: boolean;
}

/** The request to add one or more BGP policies to a specific fabric. */
export interface AddFabricBgpPeersRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** A list of BGP policies to be added to the fabric. */
  peers: BgpPeer[];
}

/** The request to update a specific BGP policies in a fabric. */
export interface UpdateFabricBgpPeerRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** The BGP peer id or name. */
  peerId: string;
  /** The updated BGP peer definition */
  peer: BgpPeer | undefined;
}

/** The request to delete a specific BGP peer in a fabric. */
export interface DeleteFabricBgpPeerRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** The BGP peer id or name. */
  peerId: string;
}

function createBaseFabricBgpPoliciesResponse(): FabricBgpPoliciesResponse {
  return { policies: [], error: undefined };
}

export const FabricBgpPoliciesResponse: MessageFns<FabricBgpPoliciesResponse> = {
  encode(message: FabricBgpPoliciesResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.policies) {
      BgpPolicy.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.error !== undefined) {
      RestError.encode(message.error, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FabricBgpPoliciesResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFabricBgpPoliciesResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.policies.push(BgpPolicy.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.error = RestError.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FabricBgpPoliciesResponse {
    return {
      policies: globalThis.Array.isArray(object?.policies)
        ? object.policies.map((e: any) => BgpPolicy.fromJSON(e))
        : [],
      error: isSet(object.error) ? RestError.fromJSON(object.error) : undefined,
    };
  },

  toJSON(message: FabricBgpPoliciesResponse): unknown {
    const obj: any = {};
    if (message.policies?.length) {
      obj.policies = message.policies.map((e) => BgpPolicy.toJSON(e));
    }
    if (message.error !== undefined) {
      obj.error = RestError.toJSON(message.error);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FabricBgpPoliciesResponse>, I>>(base?: I): FabricBgpPoliciesResponse {
    return FabricBgpPoliciesResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FabricBgpPoliciesResponse>, I>>(object: I): FabricBgpPoliciesResponse {
    const message = createBaseFabricBgpPoliciesResponse();
    message.policies = object.policies?.map((e) => BgpPolicy.fromPartial(e)) || [];
    message.error = (object.error !== undefined && object.error !== null)
      ? RestError.fromPartial(object.error)
      : undefined;
    return message;
  },
};

function createBaseGetFabricBgpPoliciesRequest(): GetFabricBgpPoliciesRequest {
  return { fabricId: "", candidate: "", includeMetadata: false };
}

export const GetFabricBgpPoliciesRequest: MessageFns<GetFabricBgpPoliciesRequest> = {
  encode(message: GetFabricBgpPoliciesRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.candidate !== "") {
      writer.uint32(18).string(message.candidate);
    }
    if (message.includeMetadata !== false) {
      writer.uint32(24).bool(message.includeMetadata);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetFabricBgpPoliciesRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetFabricBgpPoliciesRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.candidate = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.includeMetadata = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetFabricBgpPoliciesRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      candidate: isSet(object.candidate) ? globalThis.String(object.candidate) : "",
      includeMetadata: isSet(object.includeMetadata) ? globalThis.Boolean(object.includeMetadata) : false,
    };
  },

  toJSON(message: GetFabricBgpPoliciesRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.candidate !== "") {
      obj.candidate = message.candidate;
    }
    if (message.includeMetadata !== false) {
      obj.includeMetadata = message.includeMetadata;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetFabricBgpPoliciesRequest>, I>>(base?: I): GetFabricBgpPoliciesRequest {
    return GetFabricBgpPoliciesRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetFabricBgpPoliciesRequest>, I>>(object: I): GetFabricBgpPoliciesRequest {
    const message = createBaseGetFabricBgpPoliciesRequest();
    message.fabricId = object.fabricId ?? "";
    message.candidate = object.candidate ?? "";
    message.includeMetadata = object.includeMetadata ?? false;
    return message;
  },
};

function createBaseGetFabricBgpPolicyRequest(): GetFabricBgpPolicyRequest {
  return { fabricId: "", policyId: "", candidate: "", includeMetadata: false };
}

export const GetFabricBgpPolicyRequest: MessageFns<GetFabricBgpPolicyRequest> = {
  encode(message: GetFabricBgpPolicyRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.policyId !== "") {
      writer.uint32(18).string(message.policyId);
    }
    if (message.candidate !== "") {
      writer.uint32(26).string(message.candidate);
    }
    if (message.includeMetadata !== false) {
      writer.uint32(32).bool(message.includeMetadata);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetFabricBgpPolicyRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetFabricBgpPolicyRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.policyId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.candidate = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.includeMetadata = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetFabricBgpPolicyRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      policyId: isSet(object.policyId) ? globalThis.String(object.policyId) : "",
      candidate: isSet(object.candidate) ? globalThis.String(object.candidate) : "",
      includeMetadata: isSet(object.includeMetadata) ? globalThis.Boolean(object.includeMetadata) : false,
    };
  },

  toJSON(message: GetFabricBgpPolicyRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.policyId !== "") {
      obj.policyId = message.policyId;
    }
    if (message.candidate !== "") {
      obj.candidate = message.candidate;
    }
    if (message.includeMetadata !== false) {
      obj.includeMetadata = message.includeMetadata;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetFabricBgpPolicyRequest>, I>>(base?: I): GetFabricBgpPolicyRequest {
    return GetFabricBgpPolicyRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetFabricBgpPolicyRequest>, I>>(object: I): GetFabricBgpPolicyRequest {
    const message = createBaseGetFabricBgpPolicyRequest();
    message.fabricId = object.fabricId ?? "";
    message.policyId = object.policyId ?? "";
    message.candidate = object.candidate ?? "";
    message.includeMetadata = object.includeMetadata ?? false;
    return message;
  },
};

function createBaseAddFabricBgpPoliciesRequest(): AddFabricBgpPoliciesRequest {
  return { fabricId: "", policies: [] };
}

export const AddFabricBgpPoliciesRequest: MessageFns<AddFabricBgpPoliciesRequest> = {
  encode(message: AddFabricBgpPoliciesRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    for (const v of message.policies) {
      BgpPolicy.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AddFabricBgpPoliciesRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAddFabricBgpPoliciesRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.policies.push(BgpPolicy.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AddFabricBgpPoliciesRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      policies: globalThis.Array.isArray(object?.policies)
        ? object.policies.map((e: any) => BgpPolicy.fromJSON(e))
        : [],
    };
  },

  toJSON(message: AddFabricBgpPoliciesRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.policies?.length) {
      obj.policies = message.policies.map((e) => BgpPolicy.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AddFabricBgpPoliciesRequest>, I>>(base?: I): AddFabricBgpPoliciesRequest {
    return AddFabricBgpPoliciesRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AddFabricBgpPoliciesRequest>, I>>(object: I): AddFabricBgpPoliciesRequest {
    const message = createBaseAddFabricBgpPoliciesRequest();
    message.fabricId = object.fabricId ?? "";
    message.policies = object.policies?.map((e) => BgpPolicy.fromPartial(e)) || [];
    return message;
  },
};

function createBaseUpdateFabricBgpPolicyRequest(): UpdateFabricBgpPolicyRequest {
  return { fabricId: "", policyId: "", policy: undefined };
}

export const UpdateFabricBgpPolicyRequest: MessageFns<UpdateFabricBgpPolicyRequest> = {
  encode(message: UpdateFabricBgpPolicyRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.policyId !== "") {
      writer.uint32(18).string(message.policyId);
    }
    if (message.policy !== undefined) {
      BgpPolicy.encode(message.policy, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateFabricBgpPolicyRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateFabricBgpPolicyRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.policyId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.policy = BgpPolicy.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateFabricBgpPolicyRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      policyId: isSet(object.policyId) ? globalThis.String(object.policyId) : "",
      policy: isSet(object.policy) ? BgpPolicy.fromJSON(object.policy) : undefined,
    };
  },

  toJSON(message: UpdateFabricBgpPolicyRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.policyId !== "") {
      obj.policyId = message.policyId;
    }
    if (message.policy !== undefined) {
      obj.policy = BgpPolicy.toJSON(message.policy);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateFabricBgpPolicyRequest>, I>>(base?: I): UpdateFabricBgpPolicyRequest {
    return UpdateFabricBgpPolicyRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateFabricBgpPolicyRequest>, I>>(object: I): UpdateFabricBgpPolicyRequest {
    const message = createBaseUpdateFabricBgpPolicyRequest();
    message.fabricId = object.fabricId ?? "";
    message.policyId = object.policyId ?? "";
    message.policy = (object.policy !== undefined && object.policy !== null)
      ? BgpPolicy.fromPartial(object.policy)
      : undefined;
    return message;
  },
};

function createBaseDeleteFabricBgpPolicyRequest(): DeleteFabricBgpPolicyRequest {
  return { fabricId: "", policyId: "" };
}

export const DeleteFabricBgpPolicyRequest: MessageFns<DeleteFabricBgpPolicyRequest> = {
  encode(message: DeleteFabricBgpPolicyRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.policyId !== "") {
      writer.uint32(18).string(message.policyId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteFabricBgpPolicyRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteFabricBgpPolicyRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.policyId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteFabricBgpPolicyRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      policyId: isSet(object.policyId) ? globalThis.String(object.policyId) : "",
    };
  },

  toJSON(message: DeleteFabricBgpPolicyRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.policyId !== "") {
      obj.policyId = message.policyId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeleteFabricBgpPolicyRequest>, I>>(base?: I): DeleteFabricBgpPolicyRequest {
    return DeleteFabricBgpPolicyRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeleteFabricBgpPolicyRequest>, I>>(object: I): DeleteFabricBgpPolicyRequest {
    const message = createBaseDeleteFabricBgpPolicyRequest();
    message.fabricId = object.fabricId ?? "";
    message.policyId = object.policyId ?? "";
    return message;
  },
};

function createBaseFabricBgpPeersResponse(): FabricBgpPeersResponse {
  return { peers: [], error: undefined };
}

export const FabricBgpPeersResponse: MessageFns<FabricBgpPeersResponse> = {
  encode(message: FabricBgpPeersResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.peers) {
      BgpPeer.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.error !== undefined) {
      RestError.encode(message.error, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FabricBgpPeersResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFabricBgpPeersResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.peers.push(BgpPeer.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.error = RestError.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FabricBgpPeersResponse {
    return {
      peers: globalThis.Array.isArray(object?.peers) ? object.peers.map((e: any) => BgpPeer.fromJSON(e)) : [],
      error: isSet(object.error) ? RestError.fromJSON(object.error) : undefined,
    };
  },

  toJSON(message: FabricBgpPeersResponse): unknown {
    const obj: any = {};
    if (message.peers?.length) {
      obj.peers = message.peers.map((e) => BgpPeer.toJSON(e));
    }
    if (message.error !== undefined) {
      obj.error = RestError.toJSON(message.error);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FabricBgpPeersResponse>, I>>(base?: I): FabricBgpPeersResponse {
    return FabricBgpPeersResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FabricBgpPeersResponse>, I>>(object: I): FabricBgpPeersResponse {
    const message = createBaseFabricBgpPeersResponse();
    message.peers = object.peers?.map((e) => BgpPeer.fromPartial(e)) || [];
    message.error = (object.error !== undefined && object.error !== null)
      ? RestError.fromPartial(object.error)
      : undefined;
    return message;
  },
};

function createBaseGetFabricBgpPeersRequest(): GetFabricBgpPeersRequest {
  return { fabricId: "", candidate: "", includeMetadata: false };
}

export const GetFabricBgpPeersRequest: MessageFns<GetFabricBgpPeersRequest> = {
  encode(message: GetFabricBgpPeersRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.candidate !== "") {
      writer.uint32(18).string(message.candidate);
    }
    if (message.includeMetadata !== false) {
      writer.uint32(24).bool(message.includeMetadata);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetFabricBgpPeersRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetFabricBgpPeersRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.candidate = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.includeMetadata = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetFabricBgpPeersRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      candidate: isSet(object.candidate) ? globalThis.String(object.candidate) : "",
      includeMetadata: isSet(object.includeMetadata) ? globalThis.Boolean(object.includeMetadata) : false,
    };
  },

  toJSON(message: GetFabricBgpPeersRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.candidate !== "") {
      obj.candidate = message.candidate;
    }
    if (message.includeMetadata !== false) {
      obj.includeMetadata = message.includeMetadata;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetFabricBgpPeersRequest>, I>>(base?: I): GetFabricBgpPeersRequest {
    return GetFabricBgpPeersRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetFabricBgpPeersRequest>, I>>(object: I): GetFabricBgpPeersRequest {
    const message = createBaseGetFabricBgpPeersRequest();
    message.fabricId = object.fabricId ?? "";
    message.candidate = object.candidate ?? "";
    message.includeMetadata = object.includeMetadata ?? false;
    return message;
  },
};

function createBaseGetFabricBgpPeerRequest(): GetFabricBgpPeerRequest {
  return { fabricId: "", peerId: "", candidate: "", includeMetadata: false };
}

export const GetFabricBgpPeerRequest: MessageFns<GetFabricBgpPeerRequest> = {
  encode(message: GetFabricBgpPeerRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.peerId !== "") {
      writer.uint32(18).string(message.peerId);
    }
    if (message.candidate !== "") {
      writer.uint32(26).string(message.candidate);
    }
    if (message.includeMetadata !== false) {
      writer.uint32(32).bool(message.includeMetadata);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetFabricBgpPeerRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetFabricBgpPeerRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.peerId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.candidate = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.includeMetadata = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetFabricBgpPeerRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      peerId: isSet(object.peerId) ? globalThis.String(object.peerId) : "",
      candidate: isSet(object.candidate) ? globalThis.String(object.candidate) : "",
      includeMetadata: isSet(object.includeMetadata) ? globalThis.Boolean(object.includeMetadata) : false,
    };
  },

  toJSON(message: GetFabricBgpPeerRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.peerId !== "") {
      obj.peerId = message.peerId;
    }
    if (message.candidate !== "") {
      obj.candidate = message.candidate;
    }
    if (message.includeMetadata !== false) {
      obj.includeMetadata = message.includeMetadata;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetFabricBgpPeerRequest>, I>>(base?: I): GetFabricBgpPeerRequest {
    return GetFabricBgpPeerRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetFabricBgpPeerRequest>, I>>(object: I): GetFabricBgpPeerRequest {
    const message = createBaseGetFabricBgpPeerRequest();
    message.fabricId = object.fabricId ?? "";
    message.peerId = object.peerId ?? "";
    message.candidate = object.candidate ?? "";
    message.includeMetadata = object.includeMetadata ?? false;
    return message;
  },
};

function createBaseAddFabricBgpPeersRequest(): AddFabricBgpPeersRequest {
  return { fabricId: "", peers: [] };
}

export const AddFabricBgpPeersRequest: MessageFns<AddFabricBgpPeersRequest> = {
  encode(message: AddFabricBgpPeersRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    for (const v of message.peers) {
      BgpPeer.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AddFabricBgpPeersRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAddFabricBgpPeersRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.peers.push(BgpPeer.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AddFabricBgpPeersRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      peers: globalThis.Array.isArray(object?.peers) ? object.peers.map((e: any) => BgpPeer.fromJSON(e)) : [],
    };
  },

  toJSON(message: AddFabricBgpPeersRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.peers?.length) {
      obj.peers = message.peers.map((e) => BgpPeer.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AddFabricBgpPeersRequest>, I>>(base?: I): AddFabricBgpPeersRequest {
    return AddFabricBgpPeersRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AddFabricBgpPeersRequest>, I>>(object: I): AddFabricBgpPeersRequest {
    const message = createBaseAddFabricBgpPeersRequest();
    message.fabricId = object.fabricId ?? "";
    message.peers = object.peers?.map((e) => BgpPeer.fromPartial(e)) || [];
    return message;
  },
};

function createBaseUpdateFabricBgpPeerRequest(): UpdateFabricBgpPeerRequest {
  return { fabricId: "", peerId: "", peer: undefined };
}

export const UpdateFabricBgpPeerRequest: MessageFns<UpdateFabricBgpPeerRequest> = {
  encode(message: UpdateFabricBgpPeerRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.peerId !== "") {
      writer.uint32(18).string(message.peerId);
    }
    if (message.peer !== undefined) {
      BgpPeer.encode(message.peer, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateFabricBgpPeerRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateFabricBgpPeerRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.peerId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.peer = BgpPeer.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateFabricBgpPeerRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      peerId: isSet(object.peerId) ? globalThis.String(object.peerId) : "",
      peer: isSet(object.peer) ? BgpPeer.fromJSON(object.peer) : undefined,
    };
  },

  toJSON(message: UpdateFabricBgpPeerRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.peerId !== "") {
      obj.peerId = message.peerId;
    }
    if (message.peer !== undefined) {
      obj.peer = BgpPeer.toJSON(message.peer);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateFabricBgpPeerRequest>, I>>(base?: I): UpdateFabricBgpPeerRequest {
    return UpdateFabricBgpPeerRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateFabricBgpPeerRequest>, I>>(object: I): UpdateFabricBgpPeerRequest {
    const message = createBaseUpdateFabricBgpPeerRequest();
    message.fabricId = object.fabricId ?? "";
    message.peerId = object.peerId ?? "";
    message.peer = (object.peer !== undefined && object.peer !== null) ? BgpPeer.fromPartial(object.peer) : undefined;
    return message;
  },
};

function createBaseDeleteFabricBgpPeerRequest(): DeleteFabricBgpPeerRequest {
  return { fabricId: "", peerId: "" };
}

export const DeleteFabricBgpPeerRequest: MessageFns<DeleteFabricBgpPeerRequest> = {
  encode(message: DeleteFabricBgpPeerRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.peerId !== "") {
      writer.uint32(18).string(message.peerId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteFabricBgpPeerRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteFabricBgpPeerRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.peerId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteFabricBgpPeerRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      peerId: isSet(object.peerId) ? globalThis.String(object.peerId) : "",
    };
  },

  toJSON(message: DeleteFabricBgpPeerRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.peerId !== "") {
      obj.peerId = message.peerId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeleteFabricBgpPeerRequest>, I>>(base?: I): DeleteFabricBgpPeerRequest {
    return DeleteFabricBgpPeerRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeleteFabricBgpPeerRequest>, I>>(object: I): DeleteFabricBgpPeerRequest {
    const message = createBaseDeleteFabricBgpPeerRequest();
    message.fabricId = object.fabricId ?? "";
    message.peerId = object.peerId ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
